import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TranslocoModule } from "@ngneat/transloco";
import { RetrieveNet4WorkerAssignmentsRequest } from "../../core/http/request.model";
import { EndpointsService } from "../../modules/admin/endpoints/endpoints.service";

@Component({
    selector: 'app-worker-assignments-dialog',
    templateUrl: './worker-assignments-dialog.component.html',
    styleUrls: ['./worker-assignments-dialog.component.scss'],
    imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule, TranslocoModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class WorkerAssignmentDialogComponent {

    public data: { request: RetrieveNet4WorkerAssignmentsRequest, workerName: string } = inject(MAT_DIALOG_DATA);
    private dialogRef = inject(MatDialogRef<WorkerAssignmentDialogComponent>);
    private endpointsService = inject(EndpointsService);

    assignments = toSignal(this.endpointsService.retrieveNet4WorkerAssignments(this.data.request));

    closeDialog() {
        this.dialogRef.close();
    }

    minutesToText(minutes: number) {
        let negative = false;
        if (minutes < 0) {
            negative = true;
            minutes = Math.abs(minutes);
        }
        const hours = Math.floor(minutes / 60);
        let str = '';
        minutes = minutes % 60;
        if (hours > 0) {
            str = str + String(hours) + 'h ';
        }
        if (minutes > 0) {
            str = str + String(minutes) + 'm';
        }
        if (str === '') {
            return '0m';
        } else {
            return negative ? '-' + str : str;
        }
    }
}
